import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

const SubscriptionRequired: React.FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 500,
          width: '100%',
          p: 4,
          textAlign: 'center',
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: '#fef3e7',
            mb: 3,
          }}
        >
          <LockIcon sx={{ fontSize: 40, color: '#f39c12' }} />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            mb: 2,
            color: 'text.primary',
          }}
        >
          Ottimate Copilot Access Not Enabled
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          Your account does not have access to Ottimate Copilot. Please contact your administrator to enable this feature.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            onClick={() => window.location.href = '/oauth/logout'}
            sx={{
              borderColor: 'divider',
              color: 'text.secondary',
              '&:hover': {
                borderColor: 'text.secondary',
                backgroundColor: 'action.hover',
              },
            }}
          >
            Sign Out
          </Button>
          <Button
            variant="contained"
            onClick={() => window.location.href = 'mailto:support@ottimate.com'}
            sx={{
              backgroundColor: '#27c499',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1fa87d',
              },
            }}
          >
            Contact Support
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubscriptionRequired;